/**=========================================================
 * Module: toggle-state.js
 * Services to share toggle state functionality
 =========================================================*/

App.service('toggleStateService', ['$rootScope', $rootScope => {

  const storageKeyName  = 'toggleState'

  // Helper object to check for words in a phrase //
  const WordChecker = {
    hasWord(phrase, word) {
      return new RegExp(`(^|\\s)${word}(\\s|$)`).test(phrase)
    },
    addWord(phrase, word) {
      if (!this.hasWord(phrase, word)) {
        return (phrase + (phrase ? ' ' : '') + word)
      }
    },
    removeWord(phrase, word) {
      if (this.hasWord(phrase, word)) {
        return phrase.replace(new RegExp(`(^|\\s)*${word}(\\s|$)*`, 'g'), '')
      }
    }
  }

  // Return service public methods
  return {
    // Add a state to the browser storage to be restored later
    addState(classname) {
      if(!$rootScope.localStorageSupport) return
      let data = angular.fromJson($rootScope.$storage[storageKeyName])
      
      if(!data)  {
        data = classname
      }
      else {
        data = WordChecker.addWord(data, classname)
      }

      $rootScope.$storage[storageKeyName] = angular.toJson(data)
    },

    // Remove a state from the browser storage
    removeState(classname) {
      let data = null
      if($rootScope.localStorageSupport) {
        data = $rootScope.$storage[storageKeyName]
      }
      // nothing to remove
      if(!data) return

      data = WordChecker.removeWord(data, classname)

      $rootScope.$storage[storageKeyName] = angular.toJson(data)
    },
    
    // Load the state string and restore the classlist
    restoreState($elem) {
      let data = null
      if ($rootScope.localStorageSupport) {
        data = angular.fromJson($rootScope.$storage[storageKeyName])
      }
      
      // nothing to restore
      if(!data) return
      $elem.addClass(data)
    }

  }

}])